export default {
  list: [],
  item: {},
  current: 0,
  total: Number.MAX_SAFE_INTEGER,
  loaded: false
};
